"use client"

import { useState, useEffect } from "react"
import Header from "./components/Header"
import Hero from "./components/Hero"
import About from "./components/About"
import Prices from "./components/Prices"
import Process from "./components/Process"
import Contact from "./components/Contact"
import Footer from "./components/Footer"
import Gallery from "@/src/components/Gallery"
import CookieConsent from "./components/CookieConsent"
import ErrorBoundary from "./components/ErrorBoundary"
import Script from "next/script"

function App() {
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10)
    }

    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "ZAK Ferrailleur Épaviste",
    "description": "Ferrailleur épaviste à Saint-Étienne spécialisé dans l'enlèvement gratuit d'épaves et le rachat de métaux en Loire, Haute-Loire et Rhône.",
    "url": "https://www.zak-ferrailleur.fr",
    "telephone": "+33614868693",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Saint-Étienne",
      "addressRegion": "Loire",
      "postalCode": "42000",
      "addressCountry": "FR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "45.439695",
      "longitude": "4.387178"
    },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
      ],
      "opens": "08:00",
      "closes": "19:00"
    },
    "sameAs": [
      "https://www.facebook.com/share/194F5j2KNu/?mibextid=wwXIfr"
    ],
    "image": "https://www.zak-ferrailleur.fr/logo.webp",
    "priceRange": "€€"
  }

  return (
    <div className="font-sans text-gray-800">
      {/* JSON-LD structured data directly in the component */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />
      
      {/* Google Tag Manager - Only load if cookies accepted */}
      <Script
        id="gtm-script"
        strategy="lazyOnload"
        dangerouslySetInnerHTML={{
          __html: `
            var cookieConsent = window.localStorage.getItem('cookie-consent');
            if (cookieConsent === 'accepted') {
              // Only load GTM if user accepted cookies
              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','${process.env.NEXT_PUBLIC_GTM_ID || "GTM-XXXXXX"}');
            }
          `
        }}
      />
      
      <ErrorBoundary>
        <Header isScrolled={isScrolled} />
        <main>
          <Hero />
          <ErrorBoundary>
            <About />
          </ErrorBoundary>
          <ErrorBoundary>
            <Prices />
          </ErrorBoundary>
          <ErrorBoundary>
            <Process />
          </ErrorBoundary>
          <ErrorBoundary>
            <Gallery />
          </ErrorBoundary>
          <ErrorBoundary>
            <Contact />
          </ErrorBoundary>
        </main>
        <Footer />
      </ErrorBoundary>
      <CookieConsent />
    </div>
  )
}

export default App
